import { getLocalePrefix } from '@monoimin/intl';


import {
  GET_ALL_TERRITORIES_PAGINATION,
  GET_COUNTRY_PROGRAMS_EMPTY_STATE,
} from '../constants';

import getStrapiCountries from './getStrapiCountries';
import getStrapiPrograms from './getStrapiPrograms';
import prepareProgramValueFacts from './prepareProgramValueFacts';

import type { EstateProgramData, CountryProgram } from '../types';
import type { Locales } from '@monoimin/sb-types';

export const getCountryPrograms = async (locale: Locales) => {
  const getCountriesResponse = await getStrapiCountries({
    pagination: GET_ALL_TERRITORIES_PAGINATION,
    locale,
  });

  const programsDatasource = await getStrapiPrograms(locale);

  if (!programsDatasource?.entries || !getCountriesResponse?.countries) {
    return GET_COUNTRY_PROGRAMS_EMPTY_STATE;
  }

  const localePrefix = getLocalePrefix(locale);

  return Object.values(programsDatasource.entries).reduce<{
    europe: CountryProgram[];
    caribbean: CountryProgram[];
  }>((acc, item) => {
    const country = getCountriesResponse.countries.find((country) => {
      return country.code === item.key;
    });

    const value = item?.value as EstateProgramData;
    if (!country || !Array.isArray(value.facts)) {
      return acc;
    }

    const { time, investment } = prepareProgramValueFacts(value?.facts);

    const estates = country.estates as { count: number };

    const estatesCount = estates?.count || 0;

    const countryForProgram = {
      country: country.code,
      budgetString: investment,
      serviceStatus: value?.status ?? '',
      obtainingPeriod: time,
      propertyCount: estatesCount,
      url: `${localePrefix}/real-estate/${country.slug}`,
    };

    const region = value?.region_blok;

    const passCountryProgram =
      (region === 'europe' || region === 'caribbean') &&
      countryForProgram.propertyCount;

    if (passCountryProgram) {
      return { ...acc, [region]: [...acc[region], countryForProgram] };
    }

    return acc;
  }, GET_COUNTRY_PROGRAMS_EMPTY_STATE);
};

export default getCountryPrograms;
